/*
 * @Author: M.D.
 * @Date: 2020-01-14 16:37:16
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 */
import request from './axios'
import request1 from './axios1'

export default {
  // 订单详情
  getOrderDetail: params => {
    return request({
      url: '/order/goodsOrder/byIdOrderInfo',
      method: 'get',
      params
    })
  },
  // 我的订单列表
  getOrderList: params => {
    return request({
      url: '/order/goodsOrder/getPageData',
      method: 'get',
      params
    })
  },
  // 我的订单数量
  getMyOrderNumber: params => {
    return request({
      url: '/order/goodsOrder/getOrderNumber',
      method: 'get',
      params
    })
  },
  // 获取支付二维码
  getPayQr: params => {
    return request({
      url: '/order/goodsOrder/getQr',
      method: 'get',
      params
    })
  },
  // 检查是否支付
  checkIsPay: params => {
    return request1({
      url: '/order/goodsOrder/checkIsPay',
      method: 'get',
      params
    })
  },
  // checkIsPay: params => {
  //   return request1({
  //     url: '/goodsOrder/checkIsPay',
  //     method: 'get',
  //     params
  //   })
  // },
  // 商品评价
  saveComment: data => {
    return request({
      url: '/order/goods/saveComment',
      method: 'post',
      data
    })
  },
  // 修改订单状态（取消订单）
  cancelOrder: data => {
    return request({
      url: '/order/goodsOrder/updateStatus',
      method: 'post',
      data
    })
  },

  // // 提交订单
  subOrder: data => {
    return request({
      url: '/order/goodsOrder/submissionOrder',
      method: 'post',
      data
    })
  },
    // 提交订单
    // subOrder: data => {
    //   return request1({
    //     url: '/goodsOrder/submissionOrder',
    //     method: 'post',
    //     data
    //   })
    // },
  // 预支付信息（pc不需要）
  getPrePayInfo: params => {
    console.log(request.defaults)
    return request({
      url: '/order/goodsOrder/applyPay',
      method: 'get',
      params
    })
  },
  // 开发票
  supplementInvoice: data => {
    if (data.invoiceType === 2) {
      data.invoiceRiseType = -1
    }
    return request({
      url: '/order/goodsOrder/supplementInvoice',
      method: 'post',
      data
    })
  },

  // 获取vip商品
  getVipPrd: params => {
    return request({
      url: '/order/goods/getMemberGoodsId',
      method: 'get',
      params
    })
  },

  getReceivingMobile: () => {
    return request({
      url: '/order/orderContactNumber/getReceivingMobile',
      method: 'get'
    })
  },

  addReceivingMobile: (params) => {
    return request({
      url: '/order/orderContactNumber/addOrUpdate',
      method: 'get',
      params
    })
  },

  getInvoiceInfo: (params) => {
    return request({
      url: '/order/invoice/getInvoiceInfo',
      method: 'get',
      params
    })
  }
}
